import { IManagedUserRecentSummary } from '@/types';

interface RenderProps {
  /** The name of the user to display */
  userName: string;
  /** The record containing the user's email and other information */
  record: IManagedUserRecentSummary;
}

/**
 * User info cell for the manager dashboard table. This component is responsible for
 * displaying the user's name and email address.
 */
export const ManagerTableCellUserInfo: React.FC<RenderProps> = ({ userName, record }) => {
  return (
    <div className="flex flex-col items-start justify-start gap-y-0.5 text-sm">
      <div className="font-semibold text-neutral-gray-800">{userName}</div>
      <div className="text-neutral-gray-700">{record.userEmail}</div>
    </div>
  );
};

ManagerTableCellUserInfo.displayName = 'ManagerTableCellUserInfo';

export default ManagerTableCellUserInfo;
